import gtmw from './components/api/GoogleTagManagerWrapper';

// NUR FÜR TESTZWECKE: Setzt den Consent-Status standardmäßig auf 'granted'.
// Dies muss vor der GTM-Initialisierung geschehen.
gtmw.sendDefaultConsentSignal({
    'ad_storage': 'granted',
    'analytics_storage': 'granted',
    'functionality_storage': 'granted',
    'personalization_storage': 'granted',
    'security_storage': 'granted',
});

// Optional, aber sicher: Senden Sie auch ein Update-Signal.
gtmw.updateConsent({
    'ad_storage': 'granted',
    'analytics_storage': 'granted',
    'functionality_storage': 'granted',
    'personalization_storage': 'granted',
    'security_storage': 'granted',
});
